interface Props {
  resource?: string;
}

export default function NoPermission({ resource }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-28 text-center px-6">
      <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-5">
        <i className="ri-shield-cross-line text-red-400 text-3xl" />
      </div>
      <h2 className="text-xl font-bold text-[#18181B] mb-2">权限不足</h2>
      <p className="text-[#6B7280] text-sm max-w-xs">
        {resource
          ? `您没有访问「${resource}」的权限，请联系超级管理员分配相应角色。`
          : '您没有访问此页面的权限，请联系超级管理员分配相应角色。'}
      </p>
    </div>
  );
}
